import { render } from "./historyVoucher.vue?vue&type=template&id=1143b1ab&scoped=true"
import script from "./historyVoucher.vue?vue&type=script&lang=js"
export * from "./historyVoucher.vue?vue&type=script&lang=js"

import "./historyVoucher.vue?vue&type=style&index=0&id=1143b1ab&lang=scss&scoped=true"
import "./historyVoucher.vue?vue&type=style&index=1&id=1143b1ab&lang=css"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1143b1ab"]])

export default __exports__